import { fromJS } from 'immutable';
import { VIEW_GET_LOADED } from '@uncinc/react-drupal-core/dist/redux/actions/Entity/View';

import { RESET_EXERCISE_SUBMISSIONS } from '../../actions/ExerciseSubmissions';

const initialState = fromJS({
  submissions: {},
});

export default function submissions(state = initialState, action = {}) {
  switch (action.type) {
    case VIEW_GET_LOADED: {
      if (action.viewId === 'exercise_answers') {
        const submissions = {};
        action.data.entities.forEach((item) => {
          // Skip daily registrations and goals, they are handled separately.
          if (item.webform_id[0].target_id === 'daily_registration') {
            return;
          }

          submissions[item.webform_id[0].target_id] = {
            submissionId: item.sid[0].value,
            uuid: item.uuid[0].value,
            data: item.data,
          };
        });

        return state.set('submissions', submissions);
      }

      return state;
    }

    case RESET_EXERCISE_SUBMISSIONS: {
      return initialState;
    }

    default:
      return state;
  }
}
